<span class="mbs-tag_content overflow-hidden">
  <mbs-text-ellipsis [tooltip]="tooltip">
    <ng-content />
  </mbs-text-ellipsis>
</span>

@if (!clickable && closable) {
  <mbs-button
    class="mbs-tag_close-btn"
    [disabled]="disabled"
    [icon]="closeIcon"
    [isCtrl]="true"
    [size]="size ? mbsSize.xxs : undefined"
    [type]="mbsType.dark"
    (click)="mbsClose.emit(id)" />
}
